import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Countdown from "react-countdown-now";
import DealDayRenderer from "../../components/countdown/DealDayRenderer";
import { AuthContext } from "../../common/Auth"
import DealEditIcon from "../../pages/dealOfDay/DealEditIcon"
import { USERTYPES } from "../../constant/userType"
import Loader from "../../common/Loader"
import { getProductDealDay } from "../../util/products/productsAPIUtil";
import { productImageExt } from "../../util/helper";
import parseHtml from "html-react-parser";
import { Box } from "@mui/material";

const CountDownTwo = () => {

  const { themeSettingsData, userType,loading } = useContext(AuthContext)
  const [dealData, setDealData] = useState({})
  const [dealId, setDealId] = useState("")
  const [textAlign, setTextAlign] = useState("text-center")
  const [productId, setProductId] = useState("")
  const [productData, setProductData] = useState("")
  let btnStyle = {}

  useEffect(() => {
    themeSettingsData.map((i) => {
      if (i.settingsName === "dealOfDay") {
        setDealData(i.values[0]);
        setTextAlign(i.values[0].alignText)
        setProductId(i.values[0].productId)
        setDealId(i._id);
      }
    })
  }, [themeSettingsData])

  useEffect(() => {
    if (productId) {
      fetchProductData()
    }
  }, [productId])

  const fetchProductData = () => {
    // setIsLoading(true)
    Promise.resolve(getProductDealDay(productId))
      .then(values => {
        // setIsLoading(false)
        setProductData(values.data)
      }).catch(error => {
        console.log('error: ', error);
      });

  }
  btnStyle = {
    color: dealData.btnTextColor,
    backgroundColor: dealData.btnColor,
    border: 'none'
  }



  let pt = dealData.paddingTop ? dealData.paddingTop : "pt-0";
  let pb = dealData.paddingBottom ? dealData.paddingBottom : "pb-0";
  let mb = dealData.marginBottom ? dealData.marginBottom : "mt-50";
  let mt = dealData.marginTop ? dealData.marginTop : "mb-50";
  let mr = dealData.marginRight ? dealData.marginRight : "mr-0";
  let ml = dealData.marginLeft ? dealData.marginLeft : "ml-0";
  let pl = dealData.paddingLeft ? dealData.paddingLeft : "pl-0";
  let pr = dealData.paddingRight ? dealData.paddingRight : "pr-0";
  let buttonAlign = dealData.buttonAlign || "text-center";
  let fullSection = dealData.fullSection ? "container-fluid" : "container";

  return (<>
    {(loading) && (<>
				<Loader />
				</>
			)}
    <div
      className={`antera-countdown-section-container funfact-area ${pt} ${pb} ${mb} ${mt} ${mr} ${ml} ${pl} ${pr} }`}
      style={dealData.bgImage ? {backgroundImage: `url(${process.env.PUBLIC_URL + dealData.bgImage})`} : {backgroundColor:dealData.bgColor}}
    >
      <div className={`antera-countdown-content-container ${fullSection}`}>
        {Object.keys(dealData).length > 0 && (

          <div className="row align-items-center">
            {dealData.alignImage === 'right' ? <>

              <div className="col-md-6">
                <div className="edit-inline">
                  <DealEditIcon dealId={dealId} fromEditAction="topBottomspace" />
                </div>
                <div className={`antera-countdown-content funfact-content funfact-res ${textAlign}`}>
                  <div className="edit-inline">
                    <DealEditIcon dealId={dealId} fromEditAction="textdesign" />
                  </div>
                  <h2>{parseHtml(dealData.text)}</h2>
                  {new Date(dealData.deadLineDate) < new Date() && <h4>{parseHtml(dealData.expiryMsg)}</h4>}
                  {productData?.productName ? <h3 className="text-center mt-3"> {productData?.productName}</h3>: ''}
                  {productData?.productId ? <div className="text-center mt-3"> #{productData.productId}</div>: ''}
                  {productData?.inhouseId ? <div className="text-center mt-3"> {productData.inhouseId}</div>: ''}
                  <div className="edit-inline">
                    <DealEditIcon dealId={dealId} fromEditAction="timer" />
                    <div className="timer" style={{
                      marginInline: 'auto'
                    }}>
                      {dealData.deadLineDate && (
                        <Countdown date={new Date(dealData.deadLineDate)} renderer={props => <DealDayRenderer props={props} dealData={dealData} />} />
                      )}
                    </div>
                  </div>
                  <div className={`funfact-btn ${buttonAlign}-funfact`}>
                    <div className="antera-countdown-button-container edit-inline">
                      <DealEditIcon dealId={dealId} fromEditAction="btn" />
                      <Link id="hover-after" to={process.env.PUBLIC_URL + dealData.buttonLink}
                        onMouseOver={(e) => {
                          e.target.style.backgroundColor = dealData.btnHoverColor
                          e.target.style.color = dealData.btnHoverTextColor
                          var styleElem = document.head.appendChild(document.createElement("style"));
                          styleElem.innerHTML = `#hover-after:after {background: ${dealData.btnHoverColor};}`;
                        }}
                        onMouseOut={(e) => {
                          e.target.style.backgroundColor = dealData.btnColor
                          e.target.style.color = dealData.btnTextColor
                        }}
                        style={btnStyle}
                      >
                        {dealData.btnText}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="edit-inline">
                  <DealEditIcon dealId={dealId} fromEditAction="image" />
                </div>
                <div className={`${!!productData?.distinctImages?.[0]  && productImageExt(productData?.distinctImages[0]) ? 'product-img-bg' : ''} fruits-deal-img`}>
                  <Link to={process.env.PUBLIC_URL + dealData.buttonLink}>
                    <img
                      style={{ backgroundSize: "393px 372px" }}
                      src={dealData?.productImage ? dealData?.productImage : ""}
                      alt=""
                      className="antera-countdown-image"
                    />
                  </Link>
                </div>
              </div>
            </> : <>
              <div className="col-md-6">
                <div className="edit-inline">
                  <DealEditIcon dealId={dealId} fromEditAction="image" />
                </div>

                <div className={`${!!productData?.distinctImages?.[0]  && productImageExt(productData?.distinctImages[0]) ? 'product-img-bg' : ''} fruits-deal-img`}>
                  <Link to={process.env.PUBLIC_URL + dealData.buttonLink}>
                    <img
                      style={{ backgroundSize: "393px 372px" }}
                      src={dealData?.productImage ? dealData?.productImage : ""}
                      alt=""
                      className="antera-countdown-image"
                    />
                  </Link>
                </div>
              </div>
              <div className="col-md-6">
                  <div className="edit-inline">
                    <DealEditIcon dealId={dealId} fromEditAction="topBottomspace" />
                  </div>
                <div className={`funfact-content funfact-res ${textAlign}`}>
                  <div className="edit-inline">
                    <DealEditIcon dealId={dealId} fromEditAction="textdesign" />
                  </div>
                  <Box sx={{marginTop: {
                    xs: '50px',
                    md: '0px',
                    lg: '0px'
                  }}}>{parseHtml(dealData.text)}</Box>
                  {new Date(dealData.deadLineDate) < new Date() && <h4>{parseHtml(dealData.expiryMsg)}</h4>}
                  {productData?.productName ? <h3 className="text-center mt-3"> {productData?.productName}</h3>: ''}
                  {productData?.productId ? <div className="text-center mt-3"> #{productData.productId}</div>: ''}
                  {productData?.inhouseId ? <div className="text-center mt-3"> {productData.inhouseId}</div>: ''}
                  <div className="antera-countdown-container edit-inline">
                    <DealEditIcon dealId={dealId} fromEditAction="timer" />
                    <div className="timer" style={{
                      marginInline: 'auto'
                    }}>
                      {dealData.deadLineDate && (
                        <Countdown date={new Date(dealData.deadLineDate)} renderer={props => <DealDayRenderer props={props} dealData={dealData} />} />
                      )}
                    </div>
                  </div>
                  <div className={`funfact-btn ${buttonAlign}-funfact`} >
                    <div className="antera-countdown-button-container edit-inline">
                      <DealEditIcon dealId={dealId} fromEditAction="btn" />
                        <Link to={process.env.PUBLIC_URL + dealData.buttonLink}
                        onMouseOver={(e) => {
                          e.target.style.backgroundColor = dealData.btnHoverColor
                          e.target.style.color = dealData.btnHoverTextColor
                        }}
                        onMouseOut={(e) => {
                          e.target.style.backgroundColor = dealData.btnColor
                          e.target.style.color = dealData.btnTextColor
                        }}
                        style={btnStyle}
                      >
                          {dealData.btnText}
                        </Link>
                    </div>
                  </div>
                </div>

              </div>
            </>}
          </div>)}
        {Object.keys(dealData).length == 0 && userType && userType !== USERTYPES.USER && (<h3>Deal of the day settings create at admin side</h3>)}
      </div>
    </div>
    </>
  );
};

CountDownTwo.propTypes = {
  dateTime: PropTypes.string
};

export default CountDownTwo;